import { lazy } from "react";

export { RESIGNATION_REQUESTS_PATH } from "./path";
export const ResignationRequestsPage = lazy(() => import("./page"));
